import styled from 'styled-components';

import { Modal } from 'antd';

export const CustomModal = styled(Modal)`
    width: 920px !important;
`;

export const DivContainerProducts = styled.div`
    display: flex;
    margin-top: 1em;
    align-items: center;
    gap: 1em;

    @media screen and (max-width: 920px) {
        flex-direction: column;
        width: 100%;
        margin-left: 2em;
        height: 10em;
        padding: 25px;
        align-items: left;
    }
`

export const DivContainerForm = styled.div`
    form{
        width: 100%;
        margin-left: 0 !important;
    }

     @media screen and (max-width: 920px) {
        form{
            display: block;
            width: 70%;
            margin-left: 13% !important;
            border: 1px solid #000;
            padding-top: 1em;
        }
    }
`
export const DivCardModal = styled.div`
    @media screen and (max-width: 920px) {
        border: none !important;
    }
`

export const Title = styled.p`
    font-weight: bold;
    width: auto;
    position: absolute;
    z-index: 1;
    background: white;
    left: 8%;
    top: 0;
    @media screen and (max-width: 920px) {
        left: 2% !important;
        font-size: 11px;
        top: 5px !important;
        width: 70% !important;
    }
`

export const DivModalFooter = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    margin-top: 1em;

    @media screen and (max-width: 920px) {
        div{
            width: 90%;
        }
    }
`

export const SpanContainerCheckbox = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
     @media screen and (max-width: 920px) {
        flex-direction: column;
    }
`

export const TitleBank = styled.p`
    font-weight: 600;
    color: var(--primary_color);
    font-size: 12px;
    letter-spacing: normal;
`